import React, { useState } from 'react';
import axios from 'axios';
import API_BASE_URL from"../Config/config";

const EditQuestionForm = ({ question, track, onClose, onUpdate }) => {
 const [form, setForm] = useState({ ...question });

 const handleChange = (e) => {
 setForm({ ...form, [e.target.name]: e.target.value });
 };

 const handleSubmit = async (e) => {
 e.preventDefault();

 if (!form.id) {
 alert("Missing question ID");
 return;
 }

 try {
 console.log("Sending PUT to:", `${API_BASE_URL}/sgl-tables/${track}/question/${form.id}`);
 console.log("Payload:", form);

 const res = await axios.put(`${API_BASE_URL}/sgl-tables/${track}/question/${form.id}`,
 form
 );

 if (res.status === 200) {
 onUpdate(res.data); // update parent state
 onClose(); // close form
 } else {
 alert("Update failed. Status:" + res.status);
 }
 } catch (err) {
 console.error("❌ Update failed:", err);
 alert("Update error:" + (err.response?.data?.error || err.message));
 }
 };

 return (
 <div className="bg-[#111] border border-secondary text-white p-6 rounded-xl shadow-xl mt-6">
 <h3 className="text-xl font-bold text-primary mb-4">Edit Question</h3>
 <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
 <input name="question" value={form.question} onChange={handleChange} className="p-2 rounded bg-bgMain text-body col-span-2" required />
 <input name="option_a" value={form.option_a} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <input name="option_b" value={form.option_b} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <input name="option_c" value={form.option_c} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <input name="option_d" value={form.option_d} onChange={handleChange} className="p-2 rounded bg-bgMain text-body" required />
 <select name="correct_option" value={form.correct_option} onChange={handleChange} className="p-2 rounded bg-bgMain text-body col-span-2">
 <option value="A">Correct Option: A</option>
 <option value="B">Correct Option: B</option>
 <option value="C">Correct Option: C</option>
 <option value="D">Correct Option: D</option>
 </select>
 <button type="submit" className="col-span-2 mt-4 px-4 py-2 bg-secondary text-black font-bold rounded hover:bg-primary">
 Save Changes
 </button>
 <button type="button" onClick={onClose} className="col-span-2 px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-600">
 Cancel
 </button>
 </form>
 </div>
 );
};

export default EditQuestionForm;



